var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManutencao(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8333 59.3334C33.8333 65.6667 29.8333 71.3334 23.8333 73.3334V61H13.8333V73.3334C7.83334 71.3334 3.83334 65.6667 3.83334 59.3334C3.83334 53 7.83334 47.3334 13.8333 45.3334V8.66671C13.8333 7.33337 14.5 6.66671 15.5 6.66671H22.1667C23.1667 6.66671 23.8333 7.33337 23.8333 8.33337V45C29.8333 47 33.8333 52.6667 33.8333 59.3334ZM53.8333 53.3334C40.8333 53 30.5 42.6667 30.5 30C30.5 17 40.8333 6.66671 53.8333 6.66671C66.8333 6.66671 77.1667 17 77.1667 30C77.1667 43 66.8333 53.3334 53.8333 53.3334ZM53.8333 13.3334C44.5 13.3334 37.1667 20.6667 37.1667 30C37.1667 39.3334 44.5 46.6667 53.8333 46.6667C63.1667 46.6667 70.5 39.3334 70.5 30C70.5 20.6667 63.1667 13.3334 53.8333 13.3334ZM50.5 43.3334V26.6667L62.5 19.3334L65.1667 23.3334L55.5 29V43.3334H50.5Z",
    fill: "url(#paint0_linear_18_8)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_8",
    x1: 40.5,
    y1: 73.3334,
    x2: 40.5,
    y2: 6.66671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB703"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManutencao);
export default __webpack_public_path__ + "static/media/manutencao.c8f94d849b3adab81157a6e682f75441.svg";
export { ForwardRef as ReactComponent };